import React, { useState, useEffect } from 'react';
import { Button, Tabs } from 'antd';
import LoadingWrapper from '@/components/LoadingWrapper';
import Banner from '@/components/Banner';
import SceneTabpane from '@/components/SceneTabPane';
import { getSceneTopInfo } from '@/services/request';
import './index.less';
const { TabPane } = Tabs;
export default function Detail(props) {
    const [fetched, setFetched] = useState(false);
    const [state, setState] = useState({});
    const [tabWidth, setTabWidth] = useState(180);
    const { params } = props.currentRoute;
    useEffect(() => {
        getSceneTopInfo({
            bizCode: params.features,
        }).then((data) => {
            const { scenes } = data;
            const textLen = scenes.reduce((pre, next) => {
                return next.sceneName && next.sceneName.length > pre ? next.sceneName.length : pre;
            }, 0);
            const _tabWidth = textLen * 17.2 < 180 ? 180 : textLen * 17.2;
            setTabWidth(_tabWidth);
            setState(data);
            setFetched(true);
        });
    }, []);
    return (<LoadingWrapper loading={!fetched}>
      {fetched && (<div className="detail-container">
          <Banner className="detail-top-banner" title={state.title} style={{
        height: 280,
        // width: 1200,
        margin: '0 auto',
    }} wrapperStyle={{ background: '#000' }} background={state.background}>
            {state.address && (<Button type="primary" href={state.address} target="_blank">
                立即体验
              </Button>)}
          </Banner>

          <div className="detail-tab-wrapper">
            <Tabs className="detail-tabs" type="card" tabBarStyle={{
        width: 1200,
        margin: '0 auto',
    }}>
              {state.scenes.map((scene) => (<TabPane tab={<div style={{ width: tabWidth }}>{scene.sceneName}</div>} key={scene.sceneCode}>
                  <SceneTabpane scene={scene}/>
                </TabPane>))}
            </Tabs>
          </div>
        </div>)}
    </LoadingWrapper>);
}
